<template>
  <div class="enriched-checkbox">
    <PflegeCheckbox
      v-model="referredModelValue"
      :error-message="props.errorMessage"
      :has-error="props.hasError"
      :required="props.required"
      @update:model-value="onInputChange($event)"
    >
      <template #label>
        <WizcoRichtextResolver :blok="props.label" />
      </template>
    </PflegeCheckbox>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'

const props = defineProps({
  modelValue: {
    type: [Boolean, Number, Array, String],
    required: false,
    default: false
  },
  name: {
    type: String,
    required: false,
    default: null
  },
  label: {
    type: [Object, String],
    required: false,
    default: ''
  },
  required: {
    type: Boolean,
    required: false,
    default: true
  },
  hasSuccess: {
    type: Boolean,
    required: false,
    default: false
  },
  hasError: {
    type: Boolean,
    required: false,
    default: false
  },
  errorMessage: {
    type: String,
    required: false,
    default: null
  }
})

const referredModelValue = ref(props.modelValue !== '' && props.modelValue !== false) // detour to (un/)check if text is available

const generatedLabelPlain = computed(() => {
  let plainText = ''
  props.label.content.forEach((row) => {
    if (row.type !== 'blok') {
      row.content?.forEach((textNode) => {
        if (typeof textNode.text === 'string') {
          plainText += textNode.text
        }
      })
    }
  })
  return plainText
})

const emit = defineEmits(['input'])
const onInputChange = (isChecked) => {
  if (!isChecked) {
    emit('input', '')
  } else {
    emit('input', generatedLabelPlain.value)
  }
}
</script>

<style scoped>
.enriched-checkbox :deep(.checkbox) label > div > div:first-child > * {
  margin-top: 0;
}

.enriched-checkbox :deep(.checkbox) label > div > div:last-child > * {
  margin-bottom: 0;
}
</style>
